import { atom } from 'recoil';
import { PaymentDetailsResponse } from '@/types/api/mypage/paymentDetails';
import persistAtom from './recoilPersist';

/**
 * 支払明細詳細APIの結果を保持する state。
 * 返金一覧など月次明細画面で再利用するため、取得結果をそのまま保持する。
 */
export const PaymentDetailsState = atom<PaymentDetailsResponse>({
  key: 'PaymentDetailsState',
  default: {
    refund_list: [],
  },
  effects_UNSTABLE: [persistAtom],
});

export default PaymentDetailsState;
